import { OnInit, Component, Input } from '@angular/core';
import { BaseService } from 'src/modules/base/shared/services/base.service';

@Component({
    selector: 'app-widget',
    templateUrl: './widget.component.html',
    styleUrls: ['./widget.component.scss'],
    standalone: false
})
export class WidgetComponent implements OnInit {
    
    @Input() widget:any;
    @Input() selection:any;

  
    constructor(
        private baseService: BaseService
        ) {
    }

    ngOnInit() {        
       
    }

   
}